var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_vm._v("\n  © "+_vm._s(_vm.currentYear)+" - binds.co  - CNPJ 23.621.217/0001-14\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }